import React, { useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";
import { useLoop } from "./arena";

const SPOTS = 9;
const KIDS = 4;
const pick = () => { const s = new Set(); while (s.size < KIDS) s.add(Math.floor(Math.random() * SPOTS)); return s; };

// Aankh-Micholi: blindfolded seeker. Tap hiding spots to find the hidden kids before time runs out.
export default function AankhMicholi() {
  const [phase, setPhase] = useState("ready");
  const [time, setTime] = useState(30);
  const [found, setFound] = useState(new Set());
  const [shake, setShake] = useState(-1);
  const kids = useRef(pick());

  const start = () => { kids.current = pick(); setFound(new Set()); setTime(30); setShake(-1); setPhase("play"); };

  useLoop(phase === "play", (dt) => {
    setTime((t) => { const nt = t - dt; if (nt <= 0) { setPhase("lose"); return 0; } return nt; });
  });

  const tap = (i) => {
    if (phase !== "play" || found.has(i)) return;
    if (kids.current.has(i)) {
      sfx.hit?.();
      const nf = new Set(found); nf.add(i); setFound(nf);
      if (nf.size >= KIDS) { setPhase("win"); sfx.win?.(); }
    } else { setShake(i); setTime((t) => Math.max(0, t - 2)); setTimeout(() => setShake(-1), 300); }
  };

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Time" value={`${Math.ceil(time)}s`} />
        <AScore label="Found" value={`${found.size}/${KIDS}`} />
      </div>
      <p className="my-2 text-sm text-kirana-brown/70">Aankh band! Tap the bushes & spots to find hidden friends. Wrong tap = -2s.</p>
      <div data-testid="am-arena" className="relative mx-auto mb-3 grid w-full max-w-md grid-cols-3 gap-3 rounded-md border-2 border-kirana-border bg-gradient-to-b from-[#8FBF6B] to-[#6fa354] p-4">
        {Array.from({ length: SPOTS }).map((_, i) => {
          const f = found.has(i);
          return (
            <button key={i} data-testid={`am-spot-${i}`} onClick={() => tap(i)}
              className={`flex aspect-square items-center justify-center rounded-lg border-2 border-[#3a2617] text-3xl transition-transform ${f ? "bg-kirana-gold" : "bg-[#4C7A3F] hover:scale-105"} ${shake === i ? "animate-pulse" : ""}`}>
              {f ? "🧒" : phase === "play" ? "🌳" : "🌳"}
            </button>
          );
        })}
        {phase === "play" && <div className="pointer-events-none absolute inset-0 rounded-md" style={{ boxShadow: "inset 0 0 90px rgba(0,0,0,0.55)" }} />}
      </div>
      <div className="mt-3">
        {phase === "ready" && <ABtn data-testid="am-start" onClick={start} tone="gold" className="px-8 py-3">Start</ABtn>}
        {(phase === "win" || phase === "lose") && (<><AResult testId="am-result" win={phase === "win"} text={phase === "win" ? `Sabko dhoond liya! ${Math.ceil(time)}s left 🎉` : `Time up! Found ${found.size}/${KIDS}.`} /><div className="mt-3 flex justify-center"><ABtn data-testid="am-again" onClick={start} tone="green">Play Again</ABtn></div></>)}
      </div>
    </div>
  );
}
